var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-title"},[_c('span',{class:{active:_vm.type==1},on:{"click":function($event){return _vm.toChange(1)}}},[_vm._v(_vm._s(_vm.typeName1))]),_vm._v(" "),_c('span',{class:{active:_vm.type==2},on:{"click":function($event){return _vm.toChange(2)}}},[_vm._v(_vm._s(_vm.typeName2))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e35389a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/LoginTitle.vue
// module id = null
// module chunks = 